import SvgIcon from "@material-ui/core/SvgIcon";

export const HalfFilledCircleIcon = ({
  color = "black",
  backgroundColor = "transparent",
  ...props
}) => (
  <SvgIcon
    {...props}
    component="svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path d="M12,1 A11,11 0 1,0 12,23 L12,1 Z" fill={color} />

    <circle cx="12" cy="12" r="11" stroke={color} strokeWidth="2" fill="none" />
  </SvgIcon>
);
